export const UPDATE_ACCOUNT_TYPE_REQUEST = "UPDATE_ACCOUNT_TYPE_REQUEST";
export const UPDATE_ACCOUNT_TYPE_SUCCESS = "UPDATE_ACCOUNT_TYPE_SUCCESS";
export const UPDATE_ACCOUNT_TYPE_FAILURE = "UPDATE_ACCOUNT_TYPE_FAILURE";
export const UPDATE_ACCOUNT_TYPE_RESET = "UPDATE_ACCOUNT_TYPE_RESET";
export const updateAccountTypeRequest = (payload) => ({
    type: UPDATE_ACCOUNT_TYPE_REQUEST,
    payload,
});
export const updateAccountTypeSuccess = (payload) => ({
    type: UPDATE_ACCOUNT_TYPE_SUCCESS,
    payload,
});
export const updateAccountTypeFailure = (payload) => ({
    type: UPDATE_ACCOUNT_TYPE_FAILURE,
    payload,
});
export const updateAccountTypeReset = () => ({
    type: UPDATE_ACCOUNT_TYPE_RESET,
});
